/**
 * App-scoped session keys so school admin (/) and staff (/staff) on the same
 * origin do not overwrite each other's auth when used in parallel tabs/windows.
 */
const PREFIX = "dsc_admin_";

const LEGACY_TO_SCOPED: Record<string, string> = {
  token: `${PREFIX}token`,
  user: `${PREFIX}user`,
  isAuthenticated: `${PREFIX}isAuthenticated`,
  isVerified: `${PREFIX}isVerified`,
  setectedValue: `${PREFIX}setectedValue`,
  "forgot-email": `${PREFIX}forgot-email`,
};

const rawGetItem = Storage.prototype.getItem;
const rawSetItem = Storage.prototype.setItem;
const rawRemoveItem = Storage.prototype.removeItem;

(function migrateWithRaw() {
  const scopedTokenKey = LEGACY_TO_SCOPED.token;
  if (rawGetItem.call(sessionStorage, scopedTokenKey)) return;
  const legacyToken = rawGetItem.call(sessionStorage, "token");
  if (!legacyToken) return;
  Object.entries(LEGACY_TO_SCOPED).forEach(([legacy, scoped]) => {
    const value = rawGetItem.call(sessionStorage, legacy);
    if (value != null) {
      rawSetItem.call(sessionStorage, scoped, value);
      rawRemoveItem.call(sessionStorage, legacy);
    }
  });
})();

sessionStorage.getItem = (key: string) => {
  const scoped = LEGACY_TO_SCOPED[key];
  if (scoped) return rawGetItem.call(sessionStorage, scoped);
  return rawGetItem.call(sessionStorage, key);
};

sessionStorage.setItem = (key: string, value: string) => {
  const scoped = LEGACY_TO_SCOPED[key];
  if (scoped) {
    rawSetItem.call(sessionStorage, scoped, value);
    return;
  }
  rawSetItem.call(sessionStorage, key, value);
};

sessionStorage.removeItem = (key: string) => {
  const scoped = LEGACY_TO_SCOPED[key];
  if (scoped) {
    rawRemoveItem.call(sessionStorage, scoped);
    return;
  }
  rawRemoveItem.call(sessionStorage, key);
};

sessionStorage.clear = () => {
  Object.values(LEGACY_TO_SCOPED).forEach((scoped) =>
    rawRemoveItem.call(sessionStorage, scoped)
  );
  Object.keys(LEGACY_TO_SCOPED).forEach((legacy) =>
    rawRemoveItem.call(sessionStorage, legacy)
  );
  const toRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (!key) continue;
    if (key.startsWith("dsc_staff_")) continue; // never wipe staff auth
    if (key.startsWith(PREFIX)) continue;
    toRemove.push(key);
  }
  toRemove.forEach((k) => rawRemoveItem.call(sessionStorage, k));
};

export const authStorage = {
  getToken: () => sessionStorage.getItem("token"),
  clearAuth: () => {
    Object.keys(LEGACY_TO_SCOPED).forEach((k) => sessionStorage.removeItem(k));
  },
};

export default authStorage;
